"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.regexp.replace");

var _utils = _interopRequireDefault(require("../utils"));

var _performance = require("../ULog/performance");

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var getENV = _utils.default.getENV,
    isApp = _utils.default.isApp,
    urlParams = _utils.default.urlParams;

function getUUID() {
  var d = Date.now();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16); // eslint-disable-next-line

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}
/**
 * 埋点
 * 参数：
 *  {String} {required} bid：埋点唯一标志
 *  {String} uid：用户唯一标志
 *  {String} inform：渠道
 *  {String} api：web发埋点api
 *  {String} did：用户域id
 *  {String} sid：
 *  {String} un：用户名字
 * 方法：
 *  sendPV：pv
 *  sendTrack：事件
 *  sendPerformance：加载时间
 */


var ULog =
/*#__PURE__*/
function () {
  function ULog() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ULog);

    this.opts = _objectSpread({
      api: "".concat(_config.ULOG.host[getENV()]).concat(_config.ULOG.path),
      inform: urlParams.inform || '',
      bid: '',
      uid: '',
      did: '',
      sid: '',
      un: ''
    }, opts);

    window.defaultULogCallback = function () {};

    this.sendPV = this.sendPV.bind(this);
    this.sendTrack = this.sendTrack.bind(this);
    this.sendNativePV = this.sendNativePV.bind(this);
    this.sendNativeTrack = this.sendNativeTrack.bind(this);
    this.sendWeb = this.sendWeb.bind(this);
    this.sendPerformance = this.sendPerformance.bind(this);
  }

  _createClass(ULog, [{
    key: "sendPV",
    value: function sendPV() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (isApp()) {
        this.sendNativePV(eventId);
      } else {
        this.sendWeb(eventId, values);
      }
    }
  }, {
    key: "sendTrack",
    value: function sendTrack() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (isApp()) {
        this.sendNativeTrack(eventId, values);
      } else {
        this.sendWeb(eventId, values);
      }
    }
  }, {
    key: "sendNativePV",
    value: function sendNativePV() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var WLWebPV = window.WLSDK.WLWebPV;
      var _this$opts = this.opts,
          bid = _this$opts.bid,
          inform = _this$opts.inform;
      var pageName = "".concat(bid, "_").concat(eventId);

      if (inform) {
        pageName += "_".concat(inform);
      }

      if (window.WLWebPV) {
        WLWebPV && WLWebPV.pageStart({
          pageName: pageName
        });
      }

      console.log(pageName);
    }
  }, {
    key: "sendNativeTrack",
    value: function sendNativeTrack() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var WLTrack = window.WLSDK.WLTrack;
      var _this$opts2 = this.opts,
          bid = _this$opts2.bid,
          inform = _this$opts2.inform;
      var label = "".concat(bid, "_").concat(eventId);

      var values = _objectSpread({
        inform: inform
      }, _values);

      if (window.WLWebPV) {
        WLTrack && WLTrack.trackEvent({
          label: label,
          values: values
        });
      }

      console.log(label, values);
    }
  }, {
    key: "sendWeb",
    value: function sendWeb() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _bid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var _this$opts3 = this.opts,
          api = _this$opts3.api,
          inform = _this$opts3.inform,
          uid = _this$opts3.uid,
          did = _this$opts3.did,
          un = _this$opts3.un,
          sid = _this$opts3.sid;
      var bid = _bid || this.opts.bid;
      var label = "".concat(bid, "_").concat(eventId);

      var values = _objectSpread({
        inform: inform
      }, _values);

      var valuesStr = JSON.stringify(values);
      var uuid = getUUID();
      var target = "".concat(api, "?callback=defaultULogCallback&_sid_=").concat(sid, "&_un_=").concat(un, "&_uid_=").concat(uid, "&_did_=").concat(did, "\n    &bid=").concat(bid, "&label=").concat(label, "&values=").concat(valuesStr, "&_uuid_=").concat(uuid); // eslint-disable-next-line

      new Image().src = target;
      console.log(label, values);
    }
  }, {
    key: "sendPerformance",
    value: function sendPerformance() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var bid = this.opts.bid;

      var values = _objectSpread({
        bid: bid
      }, (0, _performance.performance)(), param);

      this.sendWeb('load', values, 'performance');
    }
  }, {
    key: "sendPerformancePC",
    value: function sendPerformancePC() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var values = _objectSpread({}, (0, _performance.performance)(), param);

      this.sendWeb('load', values);
    }
  }]);

  return ULog;
}();

var _default = ULog;
exports.default = _default;